import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import {
	Status,
	getStatusUrl,
	statusIconMapping,
	statusTranslationMapping,
} from 'domain/constants/status';
import { useContainerWidth } from 'library/hooks/useContainerWidth';

const MIN_WIDTH_FOR_TEXT = 100;

export interface StatusCellProps {
	status: Status | 'Null' | null;
	id: string; // unitId or SN depending on the status type, used for URL generation
}

const StatusCell = ({ status, id }: StatusCellProps) => {
	const { t } = useTranslation(['commonStatus']);
	const { ref, width } = useContainerWidth();

	const exists = status != null && statusTranslationMapping[status] != null;
	if (!exists) {
		return <></>;
	}

	const statusUrl = getStatusUrl(status as Status, id);
	const statusText = t(statusTranslationMapping[status]);
	const hasSpaceForText = width > MIN_WIDTH_FOR_TEXT;

	return (
		<span
			ref={ref}
			style={{
				display: 'flex',
				alignItems: 'center',
				overflow: 'hidden',
				width: '100%',
			}}>
			<Tooltip
				title={!hasSpaceForText ? statusText : ''}
				disableHoverListener={hasSpaceForText}
				arrow>
				<Box
					component="span"
					sx={(theme) => ({
						height: theme.spacing(3),
						width: theme.spacing(3),
						flexShrink: 0,
					})}>
					<Box component={Link} to={statusUrl} target="_blank">
						{statusIconMapping[status as Status]}
					</Box>
				</Box>
			</Tooltip>
			{hasSpaceForText && (
				<span style={{ marginLeft: 4, whiteSpace: 'nowrap' }}>
					{statusText}
				</span>
			)}
		</span>
	);
};

export default memo(StatusCell);
